import {
  Component, ViewEncapsulation, ChangeDetectionStrategy,
  Input, Renderer2, ViewChild, ElementRef, EventEmitter, Output
} from '@angular/core';

import { LoyaltyResponse } from '@pax/entities/traveler-pax';

@Component({
  selector: 'app-each-loyalty',
  templateUrl: './each-loyalty.component.html',
  styleUrls: ['./each-loyalty.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EachLoyaltyComponent {

  @Input() loyalty: LoyaltyResponse;
  @Input() isLast: boolean;
  @Input() totalItems: number;

  @Output() selectLoyalty: EventEmitter<LoyaltyResponse> = new EventEmitter();
  @Output() edit: EventEmitter<LoyaltyResponse> = new EventEmitter();
  @Output() remove: EventEmitter<LoyaltyResponse> = new EventEmitter();

  @ViewChild('loyaltyImage') public loyaltyImage: ElementRef;
  @ViewChild('planeIcon') public planeIcon: ElementRef;

  public showOptions: boolean = false;

  constructor(
    private renderer: Renderer2) { }

  get onlyOne(): boolean {
    return this.totalItems === 1;
  }

  public toggleOptions(): void {
    this.showOptions = !this.showOptions;
  }

  public errorHandler(): void {
    if (this.loyaltyImage && this.planeIcon) {
      this.renderer.setStyle(this.loyaltyImage.nativeElement, 'display', 'none');
      this.renderer.setStyle(this.planeIcon.nativeElement, 'display', 'inline');
    }
  }

  public deleteLoyalty(): void {
    this.remove.emit(this.loyalty);
  }

}
